import { sellerConstants } from '../../_constants/seller.constants';
import swal from 'sweetalert2/dist/sweetalert2.min.js';

const initialState = {
	editLoading: true,
	response: '',
	responseCode: '',
	error: false,
	errorText: ''
};

export function updateSeller(state = initialState, action) {
	switch (action.type) {
		case sellerConstants.REQUEST_UPDATE_SELLER:
			return {
				editLoading: true,
				response: '',
				error: false,
				errorText: '',
				responseCode: ''
			};
		case sellerConstants.UPDATE_SELLER_SUCCESS:
			swal({
				text: 'Updated Successfully',
				type: 'success',
				confirmButtonColor: '#3085d6',
				confirmButtonText: 'OK'
			})
			return {
				editLoading: false,
				response: action.data,
				error: false,
				errorText: '',
				responseCode: action.data.status
			};
		case sellerConstants.UPDATE_SELLER_ERROR:
			if (action.error.response.status === 400) {
				swal("", "Please fill out all required fields", "warning");
			}
			return {
				editLoading: false,
				response: '',
				error: true,
				errorText: action.error,
				responseCode: ''
			};
		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/_reducers/sellers/editSeller.reducer.js